// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__JZW6B","inner":"Footer_inner__cIGLA","nextIcon":"Footer_nextIcon__1U3qk","innerLeft":"Footer_innerLeft__3qwBg"};